import { render, staticRenderFns } from "./HerosForm.vue?vue&type=template&id=0ee84292&scoped=true"
import script from "./HerosForm.vue?vue&type=script&lang=js"
export * from "./HerosForm.vue?vue&type=script&lang=js"
import style0 from "./HerosForm.vue?vue&type=style&index=0&id=0ee84292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee84292",
  null
  
)

export default component.exports